import Marquee from "react-fast-marquee";

const ITEMS = [
  "Instructional Design",
  "Adult Learning Theory",
  "ADDIE",
  "Agile / SAM",
  "e-Learning",
  "ERP Enablement",
  "Photography",
  "Videography",
  "Graphic Design",
  "Web Design",
  "Interior Design",
  "Real Estate Flips",
  "Brand Identity",
  "Train-the-Trainer",
];

export const Ribbon = () => (
  <section data-testid="ribbon-section" className="border-y border-line bg-sand py-8 md:py-10">
    <Marquee speed={40} gradient={false} autoFill>
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center">
          <span className="font-serif italic text-4xl md:text-6xl text-ink px-10 md:px-16">{t}</span>
          <span className="text-terracotta text-2xl md:text-3xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
